import { Box, Paper, Stack, Typography } from '@mui/material';
import { PercentageChip } from '../PercentageChip';

type HomePageInvoiceStatusStatBoxProps = {
  label: string;
  value: number;
  previousMonthValue: number;
};

export const HomePageInvoiceStatusStatBox: React.FC<HomePageInvoiceStatusStatBoxProps> = ({ label, previousMonthValue, value }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        height: '100%',
        width: '150px',
      }}
    >
      <Stack
        padding="12px 16px 12px 16px"
        gap={1}
      >
        <Typography
          fontSize="13px"
          lineHeight="18px"
          fontWeight={400}
          color={theme => theme.palette.text.secondary}
        >
          {label}
        </Typography>
        <Typography
          variant='h5'
        >
          {value}
        </Typography>
        <Box>
          <PercentageChip 
            newValue={value}
            oldValue={previousMonthValue}
          />
        </Box>

        <Typography
          variant='caption'
          color={theme => theme.palette.text.disabled}
        >
          Monthly change
        </Typography>
      </Stack>
    </Paper>
  );
};